import { useTheme } from "../../../theme/ThemeProvider";
import { ITheme } from "../../../theme/ITheme";
import { IEnvironmentBarStyles } from "../../styles";

export const useEnvironmentBarStyles = (theme?: ITheme): IEnvironmentBarStyles => {
    if (theme === undefined) {
        theme = useTheme();
    }

    return {
        environmentBar: {
            position: "sticky",
            top: 0,
            zIndex: 3,
            height: "40px",
            backgroundColor: theme.palette.warning.dark,
            backgroundImage: `repeating-linear-gradient(-45deg, rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0.08) 10px, transparent 10px, transparent 20px)`,
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
        },
        environmentIcon: {
            color: theme.palette.white,
            fontSize: "1rem",
            marginRight: theme.spacingScale.tightPadding,
        },
        environmentText: {
            textAlign: "center",
            color: theme.palette.white,
            fontSize: theme.font.sizes.sm,
            fontWeight: theme.font.weights.bold,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
        },
    }
}